import React from "react";
import Select from "react-select";
import { ButtonGroup, Button, Icon } from "aible";

import FoldersHeaderContainer from "containers/Folders/FoldersHeader";
import GoogleSheetsSense from "containers/Next/Google/GoogleSheetsSense";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import BigQueryIcon from "images/bigquery.svg";
import BigQueryLogo from "images/Google-BigQuery.svg";
import AibleLogo from "images/Aible_Logo/aible-light-bg.png";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

export default class GoogleSheetsHome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isUploadingDataset: {},
      outcomeSuccess: {},
      isStartingExplore: false
    };

    if (props.googleSheetsDataset?.id) {
      console.log("-=-=-=- dataset found");
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.googleSheetsDataset && this.props.googleSheetsDataset) {
      const folderId = this.props.folderId;
      if (this.state.isUploadingDataset?.[folderId]) {
        this.setState({
          isUploadingDataset: {
            ...this.state.isUploadingDataset,
            [folderId]: false
          }
        });
      }
    }
  }

  handleUpload() {
    const { folderId, createGoogleSheetsDataset } = this.props;

    console.log("-=-=-=- uploading");

    createGoogleSheetsDataset();

    this.setState({
      isUploadingDataset: {
        ...this.state.isUploadingDataset,
        [folderId]: true
      }
    });

    // setTimeout(() => {
    //   this.setState({isUploadingDataset: {
    //     ...this.state.isUploadingDataset,
    //     [folderId]: false,
    //   }})
    // }, 5000)
  }

  renderUploadDataset() {
    const { isDatasetsLoading, googleSheetsDataset, googleSheetsData, folderId } = this.props;

    const isUploadingDataset = this.state.isUploadingDataset?.[folderId];

    return (
      <React.Fragment>
        <div className={styles.homeBodyButton}>
          <Button
            type={"primary"}
            onClick={() => this.handleUpload()}
            disabled={isUploadingDataset}
            style={{ position: "relative" }}
          >
            {isUploadingDataset ? (
              <React.Fragment>
                <LoadingIndicator
                  color={"#333"}
                  style={{
                    height: "13px",
                    width: "13px",
                    margin: "0px",
                    position: "absolute",
                    transform: "scale(0.4)",
                    top: "0px",
                    left: "8px"
                  }}
                />
                <span style={{ marginLeft: "28px" }}>{"Uploading to Big Query..."}</span>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Icon type={"targetWhite"} size={16} />
                <span style={{ marginLeft: "6px" }}>{"Analyze Dataset"}</span>
              </React.Fragment>
            )}
          </Button>
        </div>
        <div className={styles.homeBodyText}>
          Securely upload this spreadsheet to Google Big Query and analyze it using Aible
        </div>
        <div className={styles.homeBodyImageWrapper}>
          <div className={styles.homeBodyImage}>
            <img src={BigQueryLogo} alt={"Google Big Query"} />
          </div>
          <div className={styles.homeBodyImageAible}>
            <img src={AibleLogo} alt={"Aible"} />
          </div>
        </div>
      </React.Fragment>
    );
  }

  handleAnalyze(id, successValue) {
    const { openExploration, googleSheetsData } = this.props;

    const { outcomeSuccess } = this.state;

    console.log("-=-=-=- starting explore");
    this.setState({ isStartingExplore: true });

    return openExploration(id, successValue);
  }

  renderAnalyzeDataset() {
    const { isDatasetsLoading, googleSheetsDataset, googleSheetsData, folderId } = this.props;

    const { isStartingExplore, outcomeSuccess } = this.state;

    const outcomeOptions =
      googleSheetsDataset?.fields?.[googleSheetsDataset?.outcome]?.type !== "number" &&
      googleSheetsDataset?.fields?.[googleSheetsDataset?.outcome]?.data
        ? googleSheetsDataset?.datasetSuccessOptions?.map((o) => ({
            value: o,
            label: o.label
          }))
        : undefined;

    const outcomeValue =
      outcomeSuccess?.[googleSheetsDataset?.id] ||
      outcomeOptions?.find((o) => o?.value?.value === googleSheetsDataset?.defaultSuccess) ||
      outcomeOptions?.[0];

    return (
      <React.Fragment>
        <div className={styles.homeBodySelectWrapper}>
          <GoogleSheetsSense />

          {/* <div className={styles.homeBodySelectLabel}>
            {googleSheetsDataset?.outcome + (outcomeOptions?.length > 0 ? " is: " : ":")}
          </div>
          {outcomeOptions?.length > 0 && (
            <div className={styles.homeBodySelect}>
              <Select
                options={outcomeOptions}
                value={outcomeValue}
                onChange={(val) =>
                  this.setState({
                    outcomeSuccess: {
                      ...this.state.outcomeSuccess,
                      [googleSheetsDataset?.id]: val,
                    },
                  })
                }
                menuPlacement={"bottom"}
              />
            </div>
          )}
        </div>
        <div className={styles.homeBodyButton}>
          <Button
            type={"primary"}
            onClick={() => this.handleAnalyze(googleSheetsDataset?.id, outcomeValue)}
            disabled={isStartingExplore}
            style={{position: "relative"}}
          >
            {isStartingExplore ? (
              <React.Fragment>
                <LoadingIndicator
                  color={"#333"}
                  style={{
                    height: "13px",
                    width: "13px",
                    margin: "0px",
                    position: "absolute",
                    transform: "scale(0.4)",
                    top: "0px",
                    left: "8px",
                  }}
                />
                <span style={{marginLeft: "28px"}}>{"Starting Exploration..."}</span>
              </React.Fragment>
            ) : "Explore Dataset"}
          </Button> */}
        </div>
      </React.Fragment>
    );
  }

  renderBody() {
    const { isDatasetsLoading, googleSheetsDataset, googleSheetsData, folderId, children } = this.props;

    if (isDatasetsLoading) {
      return (
        <div
          style={{
            height: "calc(100vh - 60px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <LoadingIndicator style={{ margin: "0px" }} />
        </div>
      );
    }

    const isUploadingDataset = this.state.isUploadingDataset?.[folderId];

    return (
      <div className={styles.homeBodyWrapper}>
        <div className={styles.homeBodyHeader}>
          {googleSheetsDataset ? (
            <div className={styles.homeBodyHeaderIcon}>
              <img src={BigQueryIcon} alt={"Big Query"} />
            </div>
          ) : (
            <React.Fragment />
          )}
          <div className={styles.homeBodyHeaderTextWrapper}>
            <div className={styles.homeBodyTitle}>{googleSheetsData?.name}</div>
            <div className={styles.homeBodySubtitle}>{googleSheetsData?.sheetName}</div>
          </div>
        </div>
        {googleSheetsDataset ? this.renderAnalyzeDataset() : this.renderUploadDataset()}
      </div>
    );
  }

  render() {
    const { isDatasetsLoading } = this.props;

    return (
      <div className={styles.homeWrapper}>
        <FoldersHeaderContainer />
        {this.renderBody()}
      </div>
    );
  }
}
